import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import millify from 'utils/millify';
import Tooltip from '@material-ui/core/Tooltip';
import { stripDecimalsAndFormat } from 'utils/misc';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import { Can } from 'utils/permissions';

const styles = theme => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  statWrapper: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.secondary[900],
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  value: {
    marginLeft: '0.5rem',
    fontSize: '1rem',
    fontWeight: 600,
    color: theme.palette.secondary.text,
  },
  divider: {
    margin: '0 1rem',
    width: '0.625rem',
    backgroundColor: theme.palette.grey.contrastText,
    transform: 'rotate(90deg)',
  },
});

const Summary = ({
  classes, count, totalReach, averageDaysRotting, numberOfRottingOpportunities,
}) => (
  <div className={classes.wrapper}>
    <div className={classes.statWrapper}>
      <span className>Leads</span>
      <span className={classes.value}>{count}</span>
      <Can I="see" a="Rotting">
        <span className="ml-2 text-red-400">({numberOfRottingOpportunities || 0}, {stripDecimalsAndFormat(averageDaysRotting) || 0}d)</span>
        <a className="hover:text-blue-600 text-gray-400" href="https://help.prvolt.com/en/articles/8337059-opportunities-summary-data" target="_blank" rel="noopener noreferrer">
          <HelpOutlineOutlinedIcon className="ml-1 w-4 cursor-pointer" />
        </a>
      </Can>
    </div>
    <hr className={classes.divider} />
    <div className={classes.statWrapper}>
      <span className>Potential Reach</span>
      <span className={classes.value}>
        <Tooltip title={stripDecimalsAndFormat(totalReach)}>
          <span>{millify(totalReach)}</span>
        </Tooltip>
      </span>
    </div>
  </div>
);

Summary.propTypes = {
  classes: PropTypes.element.isRequired,
  count: PropTypes.number.isRequired,
  totalReach: PropTypes.number.isRequired,
  averageDaysRotting: PropTypes.number.isRequired,
  numberOfRottingOpportunities: PropTypes.number.isRequired,
};

export default withStyles(styles)(Summary);
